import { Prop, Emit, Watch, Component, Vue } from 'vue-property-decorator';
import { isNull, isEmpty, pick, any, isStringNull } from '@/shared/utils/utils';
import { fill } from '@/shared/utils/array';
import _ from '@/shared/lodash.global';

@Component
export default class RowsComponent extends Vue {

    @Prop({ default() { return [] }}) data: any[];
    @Prop({ default: true }) showClear: boolean
    @Prop({ default: true }) showRowCount: boolean
    @Prop({ default: null }) sortColumn: string;
    @Prop({ default() { return [] }}) requiredFields: string[];
    @Prop({ default: 5 }) defaultRows: number;
    @Prop({ default: 'Dumac.CustomizedTableView.Rows' }) label: string
    @Prop() newRecordCallback: () => any;

    @Emit('change') notifyChange(value: any) { }
    @Emit('sort') notifySort(value: any) { }

    rows: any[] = [];

    @Watch('data', { immediate: true })
    onDataChanged(data: any[]) {
        this.rows = !isEmpty(data)
            ? data
            : fill([], this.defaultRows, null, () => this.newRecordCallback())
    }

    get rowCount(): number {
        return !isEmpty(this.rows)
            ? this.rows.length
            : this.defaultRows;
    }
    set rowCount(value: number) {
        if (value > this.rows.length) {
            this.rows = fill(this.rows,
                value,
                p => p,
                () => this.newRecordCallback())
        } else {
            this.rows = this.rows.slice(0, value);
        }

        this.notifyChange(this.rows);
    }

    get minRows(): number {
        const index = this.rows.findIndex(el => {
            return any(pick(el, ...this.requiredFields), p => !isNull(p))
        })

        return Math.max(index + 1, 1)
    }

    async clear() {
        if (await this.$confirm('Clear the Table?')) {
            this.notifyChange(fill([], this.defaultRows, null, () => this.newRecordCallback()));
        }
    }

    sort() {
        if (this.sortColumn) {
            // sort rows only if sorting column has value
            // all other rows will be added into the end of the array
            const emptyFilterRows =
                this.rows.filter(obj => isEmpty(obj[this.sortColumn]) || isStringNull(obj[this.sortColumn]));
            const orderedRows = _.orderBy(this.rows.filter(obj => !emptyFilterRows.includes(obj)), [this.sortColumn]);
            orderedRows.push(...emptyFilterRows);
            this.rows = orderedRows;
            this.notifySort(this.rows);
        }
    }
}
